import React, { Component } from 'react'
import PropTypes from 'prop-types'
import css from './MetaEdit.module.sass'
import 'brace'
import AceEditor from 'react-ace'
import 'brace/mode/json'
import 'brace/theme/tomorrow'
import { Button, Label, Popup, Icon } from 'semantic-ui-react'
import { metaToTimeline } from 'utils/functions'
import v4 from 'uuid/v4'

class MetaEditForm extends Component {
  constructor () {
    super(...arguments)

    this.state = {
      code: '',
      error: '',
      isSaveBtnDisabled: true,
      isEditorActive: false,
      isNewEvent: false
    }

    this.selectedMetaId = null

    this.handleKeyDown = this.handleKeyDown.bind(this)
    this.handleChangeEditor = this.handleChangeEditor.bind(this)
    this.handleSaveEvent = this.handleSaveEvent.bind(this)
    this.handleFocusEditor = this.handleFocusEditor.bind(this)
    this.handleBlurEditor = this.handleBlurEditor.bind(this)

    window.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillReceiveProps (nextProps, nextState) {
    const { activeItem } = nextProps

    if (activeItem) {
      const newMetaItem = {
        dts: activeItem.dts,
        meta: activeItem.meta
      }

      if (newMetaItem.meta && newMetaItem.meta.body) newMetaItem.meta.body = decodeURIComponent(newMetaItem.meta.body)
      this.selectedMetaId = activeItem.id

      const metaJSON = JSON.stringify(newMetaItem, null, '\t')

      this.setState({
        code: metaJSON,
        error: '',
        isSaveBtnDisabled: true,
        isNewEvent: newMetaItem.meta && newMetaItem.meta.action && newMetaItem.meta.action === 'new event'
      })
    }
  }

  componentWillUnmount () {
    window.removeEventListener('keydown', this.handleKeyDown)
  }

  handleChangeEditor (code) {
    this.setState({
      code,
      isSaveBtnDisabled: this.state.code === code
    })
  }

  handleKeyDown (e) {
    if (
      this.state.isEditorActive &&
      !this.state.isSaveBtnDisabled &&
      e.ctrlKey &&
      e.shiftKey &&
      e.keyCode === 83
    ) { // Ctrl + Shift + S
      this.handleSaveEvent()
    }
  }

  handleSaveEvent () {
    let metaItem
    try {
      metaItem = JSON.parse(this.state.code)
    } catch (e) {
      this.setState({ error: '¯\\_(ツ)_/¯ - не правильный формат JSON', isSaveBtnDisabled: false })
      return false
    }

    metaItem.id = this.selectedMetaId

    if (
      metaItem.meta && metaItem.dts && metaItem.meta.action &&
      (metaItem.meta.action === 'cut-start' || metaItem.meta.action === 'cut-stop')) {
      const validateResult = this._validateNewItem(metaItem)

      if (validateResult.error) {
        this.setState({ error: validateResult.error, isSaveBtnDisabled: false })
        return false
      }
      if (validateResult.dts) {
        const newItem = {
          id: v4(),
          dts: validateResult.dts,
          meta: {action: metaItem.meta.action === 'cut-start' ? 'cut-stop' : 'cut-start'}
        }
        this.props.addItem({metaItem: newItem})
      }
    }
    this.setState({
      error: '',
      isSaveBtnDisabled: true,
      isNewEvent: false
    })
    this.props.updateItem({ metaItem })
  }

  handleFocusEditor () {
    this.setState({ isEditorActive: true })
  }

  handleBlurEditor () {
    this.setState({ isEditorActive: false })
  }

  _validateNewItem (item) {
    const { playerElement } = this.props
    const dts = parseInt(item.dts)
    const dtsSecond = item.meta.action === 'cut-start' ? dts + 10000 : dts - 10000

    if (
      (dts && dts >= 0 && dts <= playerElement.duration * 1000)
    ) {
      if (
        this.state.isNewEvent &&
        (dtsSecond && dtsSecond >= 0 && dtsSecond <= playerElement.duration * 1000) &&
        !this._checkIntersect(dts, dtsSecond)
      ) return { dts: dtsSecond, error: '' }
      else if (
        !this.state.isNewEvent
      ) return { error: '' }
    }
    return { error: `Некорректное значение параметра ${item.meta.action}` }
  }

  _checkIntersect (start, end) {
    const cuts = metaToTimeline(this.props.data)
    let isIntersect = false

    for (let item of cuts) {
      if (
        start < item.end.getTime() &&
        end > item.start.getTime()
      ) {
        isIntersect = true
      }
    }

    return isIntersect
  }

  render () {
    const { activeItem } = this.props
    const { error } = this.state

    if (!activeItem) return <div className={css.placeholder}>Выберите событие для редактирования...</div>

    return (
      <div className={css.wrapper}>
        <div className={css.info}>
          <Popup
            trigger={<Icon circular name='info' />}
            content='Для сохранения можете использовать комбинацию клавиш [Ctrl + Shift + S]'
            size='small'
            position='left center'
          />
        </div>
        <div className={css.editor}>
          <AceEditor
            mode='json'
            theme='tomorrow'
            value={this.state.code}
            focus
            tabSize={2}
            fontSize={14}
            width='100%'
            height='100%'
            onChange={this.handleChangeEditor}
            onFocus={this.handleFocusEditor}
            onBlur={this.handleBlurEditor}
          />
        </div>
        <div className={css.controls}>
          <Button
            className={css.saveBtn}
            content='Сохранить изменения'
            size='tiny'
            color='orange'
            onClick={this.handleSaveEvent}
            disabled={this.state.isSaveBtnDisabled}
          />
          { error && <Label basic color='red' pointing='left'>{error}</Label> }
        </div>
      </div>
    )
  }
}

const {
  object,
  func
} = PropTypes

MetaEditForm.propTypes = {
  data: object.isRequired,
  activeItem: object,
  playerElement: object,
  addItem: func.isRequired,
  updateItem: func.isRequired
}

export default MetaEditForm



// WEBPACK FOOTER //
// ./src/components/MetaEditForm/MetaEditForm.js